/* eslint-disable @next/next/no-img-element */
import React, { useState, useEffect } from "react";
import Link from "next/link";
import dynamic from "next/dynamic";
const Acc = dynamic(
  import("@chakra-ui/react").then((mod) => mod.Acc),
  { ssr: false }
); // disable ssr
import { useDispatch } from "react-redux";
import { profileRoute } from "../../store/actions/actions";
import { Box, Image, Flex, Heading } from "@chakra-ui/react";
import { useDisclosure } from "@chakra-ui/react";
import { signIn, signOut, useSession } from "next-auth/client";
import { useRouter } from "next/router";
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuItemOption,
  MenuGroup,
  MenuOptionGroup,
  MenuIcon,
  MenuCommand,
  MenuDivider,
} from "@chakra-ui/react";
import styles from "./ZoraHeader.module.scss";
const zoraHeader = (props) => {
  // const [isOn, toggleIsOn] = useToggle();
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [onSwitch, setOnSwitch] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [session, loadingSession] = useSession();
  const [artistData, setArtistData] = useState(null);
  const router = useRouter();
  const userEmail = session?.user?.email;
  useEffect(async () => {
    const searchData = { email: userEmail };
    var idRes = await fetch("/api/businessSingle", {
      method: "POST",
      body: JSON.stringify(searchData),
    });
    idRes = await idRes?.json();

    const userId = idRes?.data;
    setArtistData(userId);
  }, [userEmail]);
  const dispatch = useDispatch();
  const onClickHandler = () => {
    router.push("/account/profile");
    dispatch(profileRoute("publicProfile"));
  };

  return (
    <header className="zora__header">
      {/* desktop */}
      <div className="displaynone">
        <Box
          pb={4}
          pt={3}
          borderBottom="1px"
          borderColor="#3333331a"
          display={{ xl: "block", lg: "block", sm: "none", md: "block" }}
          position="relative"
          className="silkCarasole navbarContainer"
        >
          <Flex align="" flexDirection="row" justifyContent="space-between">
            <Flex ml={{ lg: "-17px", md: "-17px", xl: "0px", sm: "0px" }}>
              <Box w="233px" h="47x" cursor={"pointer"}>
                <Link href="/">
                  <img
                    src="/new-ui/images/coverclap-logo.svg"
                    alt="CoverClap"
                    loading="lazy"
                    width={"233px"}
                  />
                </Link>
              </Box>
              <Box as="p" pl="70px" pt="6px" fontSize={"18px"}>
                {props.blog && <Link href={"/blog"}> Blog</Link>}
              </Box>
            </Flex>

            <Box style={{ display: "flex", flexDirection: "row" }}>
              {artistData?.onBoarded && session ? (
                <a onClick={onClickHandler}>
                  <img
                    src={"/" + props.data.profleIcon}
                    alt={""}
                    mt={1}
                    style={{
                      width: "30px",
                      height: "36px",
                      marginRight: "23px",
                      cursor: "pointer",
                    }}
                  />
                </a>
              ) : (
                ""
              )}
              {!session ? (
                <>
                  <Heading
                    cursor="pointer"
                    onClick={signIn}
                    mt={1}
                    fontSize="15px"
                    lineHeight="25.5px"
                    className="silkCarasole2"
                    fontWeight="300"
                    fontFamily="Poppins"
                    color="#333333"
                  >
                    SIGN IN
                  </Heading>
                </>
              ) : (
                <>
                  <div>
                    <Menu>
                      <MenuButton>
                        <Image
                          boxSize="2rem"
                          borderRadius="full"
                          src={session?.user.image}
                          width={30}
                          height={30}
                          alt={session?.user.name}
                        />
                      </MenuButton>
                      <MenuList
                        paddingLeft="28px"
                        paddingRight="28px"
                        style={{ width: "328px" }}
                      >
                        <MenuItem minH="48px" marginBottom="20px">
                          <Image
                            boxSize="2rem"
                            borderRadius="full"
                            width={25}
                            height={25}
                            src={session?.user.image}
                          />
                          <span
                            style={{
                              color: "#000000",
                              fontWeight: "500",
                              fontSize: "14px",
                              lineHeight: "24px",
                              marginLeft: "17px",
                            }}
                          >
                            {/* my point */}
                            {artistData
                              ? artistData?.businessName
                              : session?.user.name}
                          </span>
                        </MenuItem>
                        <MenuItem
                          minH="48px"
                          style={{
                            color: "#000000",
                            fontSize: "14px",
                            lineHeight: "21px",
                          }}
                        >
                          <span>Gift card balance: CA $0.00</span>
                        </MenuItem>
                        {!artistData?.onBoarded && <MenuDivider />}
                        {!artistData?.onBoarded && (
                          <MenuItem
                            minH="48px"
                            minW="310px"
                            style={{
                              color: "#000000",
                              fontSize: "14px",
                              lineHeight: "21px",
                            }}
                          >
                            {artistData ? (
                              <span>Your profile is under activation ... </span>
                            ) : (
                              <span>
                                {" "}
                                <Link href="onBoarding">
                                  Get a free Stylist Account
                                </Link>
                              </span>
                            )}
                          </MenuItem>
                        )}
                        <MenuDivider />
                        <MenuItem
                          minH="48px"
                          style={{
                            color: "#000000",
                            fontSize: "14px",
                            lineHeight: "21px",
                          }}
                          onClick={() => signOut()}
                        >
                          <span>Sign Out</span>
                        </MenuItem>
                      </MenuList>
                    </Menu>
                  </div>
                </>
              )}
            </Box>
          </Flex>
        </Box>
      </div>

      {/* /desktop */}
      {/* mobile */}
      <Box
        display={{ xl: "none", lg: "none", sm: "block", md: "none" }}
        py={4}
        borderBottom="1px solid rgba(51,51,51,.101961)"
        position="relative"
        w={{ xl: "53.83%", lg: "660px", sm: "100%", md: "660px" }}
        className="silkCarasole"
      >
        <div className="divContainer">
          {/* hamburger */}
          <Flex
            alignItems="center"
            flexDirection="row"
            justifyContent="space-between"
          >
            <div
              onClick={() => {
                setOnSwitch(!onSwitch);
              }}
            >
              <img
                src="../../images/Vector.png"
                alt="Icon"
                style={{ height: "24px", width: "24px" }}
              />
            </div>

            {/* /hamburger */}
            <Box w="171px" h="34.5px" cursor={"pointer"}>
              <Link href={"/"}>
                <img
                  src="/new-ui/images/coverclap-logo.svg"
                  alt="CoverClap"
                  loading="lazy"
                  width={"233px"}
                />
              </Link>
            </Box>
            <Box h="30px" style={{ display: "flex", flexDirection: "row" }}>
              {artistData?.onBoarded && session ? (
                <a onClick={onClickHandler}>
                  <img
                    src={props.data.profleIcon}
                    alt={""}
                    mt={1}
                    style={{
                      width: "30px",
                      height: "36px",
                      marginRight: "23px",
                      cursor: "pointer",
                    }}
                  />
                </a>
              ) : (
                ""
              )}
              {!session ? (
                <>
                  <Heading
                    cursor="pointer"
                    onClick={signIn}
                    mt={1}
                    fontSize="15px"
                    lineHeight="25.5px"
                    className="silkCarasole2"
                    fontWeight="300"
                    fontFamily="Poppins"
                    color="#333333"
                  >
                    SIGN IN
                  </Heading>
                </>
              ) : (
                <>
                  <div>
                    <Menu>
                      <MenuButton>
                        <Image
                          boxSize="2rem"
                          borderRadius="full"
                          src={session?.user.image}
                          width={30}
                          height={30}
                          alt={session?.user.name}
                        />
                      </MenuButton>
                      <MenuList
                        paddingLeft="28px"
                        paddingRight="28px"
                        style={{ width: "328px" }}
                      >
                        <MenuItem minH="48px" marginBottom="20px">
                          <Image
                            boxSize="2rem"
                            borderRadius="full"
                            width={25}
                            height={25}
                            src={session?.user.image}
                          />
                          <span
                            style={{
                              color: "#000000",
                              fontWeight: "500",
                              fontSize: "14px",
                              lineHeight: "24px",
                              marginLeft: "17px",
                            }}
                          >
                            {session?.user.name}
                          </span>
                        </MenuItem>
                        <MenuItem
                          minH="48px"
                          style={{
                            color: "#000000",
                            fontSize: "14px",
                            lineHeight: "21px",
                          }}
                        >
                          <span>Gift card balance: CA $0.00</span>
                        </MenuItem>
                        {!artistData?.onBoarded && <MenuDivider />}
                        {!artistData?.onBoarded && (
                          <MenuItem
                            minH="48px"
                            minW="310px"
                            style={{
                              color: "#000000",
                              fontSize: "14px",
                              lineHeight: "21px",
                            }}
                          >
                            {artistData ? (
                              <span>Your profile is under activation... </span>
                            ) : (
                              <span>
                                {" "}
                                <Link href="onBoarding">
                                  Get a free Stylist Account
                                </Link>
                              </span>
                            )}
                          </MenuItem>
                        )}
                        <MenuDivider />
                        <MenuItem
                          minH="48px"
                          style={{
                            color: "#000000",
                            fontSize: "14px",
                            lineHeight: "21px",
                          }}
                          onClick={() => signOut()}
                        >
                          <span>Sign Out</span>
                        </MenuItem>
                      </MenuList>
                    </Menu>
                  </div>
                </>
              )}
            </Box>
          </Flex>
          {/* menu */}

          <div className={`header-wrapper ${onSwitch ? "active" : ""}`}>
            <div className="header-menu">
              {/* upper */}
              <div className="header-menu-upper">
                <div className="header-menu-upper-box">
                  <Box h="20.5px">
                    <Image
                      src={props.data.logo}
                      alt="CoverClap Logo"
                      objectFit="contain"
                      boxSize="100%"
                    />
                  </Box>

                  <div
                    className="closeMobileButton"
                    onClick={() => {
                      setOnSwitch(!onSwitch);
                    }}
                  >
                    <img src="../images/cancel.svg" alt="Zorastreet" />
                  </div>
                </div>
              </div>
              <Box p={"40px"}>
                <div className={styles.item}>
                  {props.blog && <Link href={"/blog"}> Blog</Link>}
                </div>
              </Box>
            </div>
            <div
              className="header-overlay"
              onClick={() => {
                setOnSwitch(!onSwitch);
              }}
            ></div>
          </div>
          {/* /menu */}
        </div>
      </Box>
      {/* /mobile */}
    </header>
  );
};

zoraHeader.propTypes = {};

export default zoraHeader;
